export enum HallowABFlag {
  WebMediumOnboarding = "web_medium_onboarding",
  WebStrikethrough = "web_strikethrough_text",
}
